module.exports = __webpack_public_path__ + "static/media/gestioneVoucher.9ca14dab.png";